// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "asset_upload_batch".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { assetUploadBatchStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "asset_upload_batch" table (1:1 with a DB row, on the wire). */
export const assetUploadBatchAtomSchema = z.object({
    id: z.string(),
    totalAssets: z.number(),
    completedAssets: z.number(),
    failedAssets: z.number(),
    status: z.enum(assetUploadBatchStatusValues),
    organizationId: z.string(),
    createdById: z.string(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=assetUploadBatch.js.map